import React from "react";
import { useNavigate } from "react-router-dom";
import MobileHeader from "./component/MobileHeader";
import MobileSingleLotsAnimation from "./component/MobileSingleLotsAnimation";

function MobileLiveView({paidEmdOfferData}) {
  const navigate = useNavigate();
 

  return (
    <div className="full-width flex column gap-1 p-1">
      <span className={`valign-wrapper gap-1`}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>

        <h4>Live room</h4>
      </span>
      <MobileHeader singleAuctionData={paidEmdOfferData?.auction} />
      <MobileSingleLotsAnimation singleAuctionData={paidEmdOfferData}/>
    </div>
  );
}

export default MobileLiveView;
